import { createContext, useContext } from "react";
import { ColumnMenuId } from "./types";

const ColumnMenuIdContext = createContext<ColumnMenuId>("");

export const useColumnMenuId = () => useContext(ColumnMenuIdContext);

export const ColumnMenuIdProvider = ColumnMenuIdContext.Provider;
